import { render, staticRenderFns } from "./AboutPageHero.vue?vue&type=template&id=745fd096&scoped=true"
import script from "./AboutPageHero.vue?vue&type=script&lang=ts"
export * from "./AboutPageHero.vue?vue&type=script&lang=ts"
import style0 from "./AboutPageHero.vue?vue&type=style&index=0&id=745fd096&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "745fd096",
  null
  
)

export default component.exports